export default "__VITE_ASSET__C5b9iHD9__"